import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import PropertyLocation from '../components/PropertyLocation';
import Information from '../components/Information';
import LandPropertyAssessment from '../components/land-property-assessment/container/LandPropertyAssessmentContainer';
import LandSupersededAssessment from '../components/land-superseded-assessment/container/LandSupersededAssessmentContainer';
import * as actions from '../action';
import * as c from '../constant';
import LandHistoryContainer from '../components/land-history/container/LandHistoryContainer';
import LandAppraisalContainer from '../components/land-appraisal/container/LandAppraisalContainer';
import LandTransactionsContainer from '../components/land-transactions/container/LandTransactionsContainer';
import PaymentHistory from '../components/payment-history/container/PaymentHistory';

function LandApplicationContent({
  match,
  list,
  applicationId,
  getSingleLandApplication,
  applicationInfo,
  handleAddModal,
  handleCancel,
  handlePost,
  handleRevert,
  handleEdit,
  permissions,
  handleLogsModal,
  handleViewSOA,
  ordinanceRevisionId,
}) {
  const [activeTab, setActiveTab] = useState(1);
  const [formData, setFormData] = useState({
    scroll: 0,
  });
  const scrollref = React.createRef();

  const handleActivePage = (index) => () => {
    setActiveTab(index);
  };

  const scrollToLeft = (e) => {
    e.preventDefault();
    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const val = formData.scroll - slide < 0 ? 0 : formData.scroll - slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  const isApprovalEmpty =
    _.isEmpty(applicationInfo, 'attributes.appraised_assessed_by_id') ||
    _.isEmpty(applicationInfo, 'attributes.recommending_by_id') ||
    _.isEmpty(applicationInfo, 'attributes.approved_by_id');

  useEffect(() => {
    if (match.params.applicationId && !_.isEmpty(list)) {
      getSingleLandApplication(match.params.applicationId);
    }
  }, [match.params.applicationId, list]);

  const scrollToRight = (e) => {
    e.preventDefault();

    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const calculatedWidth = width - slide;
    const val =
      formData.scroll + slide > calculatedWidth
        ? calculatedWidth
        : formData.scroll + slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getSingleLandApplication(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getSingleLandApplication(applicationId);
  }, [applicationId]);

  return (
    <div className="card-section-content container-fluid">
      <div className="p-3">
        <div className="d-flex justify-content-between mb-2">
          <div className="col-3">
            <h1 className="transaction-company my-2">
              {_.get(applicationInfo, 'attributes.tdn')}
            </h1>
          </div>
          <div className="col-9 d-flex">
            <div className="ml-auto" />
            {Acl(permissions, ['E2E RPT LAND APPLICATION EDIT']) &&
              ['POSTED', 'CANCELLED'].indexOf(
                _.get(applicationInfo, 'attributes.status')
              ) <= -1 && (
                <div className="ml-3">
                  <button
                    type="button"
                    onClick={handleEdit(applicationInfo)}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                  >
                    Edit&nbsp;
                  </button>
                </div>
              )}
            {Acl(permissions, ['E2E RPT LAND APPLICATION POST']) &&
              [
                'PENDING',
                'FOR APPRAISAL AND ASSESSMENT',
                'FOR REASSESSMENT',
              ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 &&
              (_.get(
                applicationInfo,
                'included.transactionCode.attributes.code'
              ) !== 'TR' ||
                !isApprovalEmpty) && (
                <div className="ml-3">
                  <button
                    type="button"
                    onClick={handlePost(applicationInfo)}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                  >
                    Post&nbsp;
                  </button>
                </div>
              )}
            {Acl(permissions, ['E2E RPT LAND APPLICATION REVERT']) && (
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT NEW DISCOVERY']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'DC') ||
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT SUBDIVISION']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'SD') ||
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT CONSOLIDATION']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'CS') ||
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT PHYSICAL CHANGE']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'PC') ||
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT DESTRUCTION']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'D') ||
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT RECLASSIFICATION']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'R') ||
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT DISPUTE']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'DP') ||
                (Acl(permissions, ['E2E RPT LAND APPLICATION REVERT TRANSFER']) &&_.get(applicationInfo, 'included.transactionCode.attributes.code') === 'TR')
              ) &&
              ['CANCELLED'].indexOf(
                _.get(applicationInfo, 'attributes.status')
              ) > -1 && (
                <div className="ml-3">
                  <button
                    type="button"
                    onClick={handleRevert(applicationInfo)}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                  >
                    Revert&nbsp;
                  </button>
                </div>
              )}
            {Acl(permissions, ['E2E RPT LAND APPLICATION UNPOST']) &&
              _.get(applicationInfo, 'attributes.status') === 'POSTED' && (
                <div className="ml-3">
                  <button
                    type="button"
                    onClick={handleCancel(applicationInfo)}
                    className="btn btn-danger font-weight-bold px-4 ml-auto"
                  >
                    Unpost&nbsp;
                  </button>
                </div>
              )}
            {Acl(permissions, ['E2E RPT LAND APPLICATION ADD']) &&
              ['CANCELLED'].indexOf(
                _.get(applicationInfo, 'attributes.status')
              ) <= -1 && (
                <div className="ml-3">
                  <button
                    type="button"
                    onClick={handleAddModal}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                  >
                    <i className="fas fa-plus" /> Add&nbsp;
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div className="col-12 d-flex">
            {Acl(permissions, ['E2E RPT LAND APPLICATION LOGS']) && (
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleLogsModal(applicationInfo)}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                >
                  Logs
                </button>
              </div>
            )}
          </div>
        </div>
        {!_.isEmpty(applicationInfo) ? (
          <>
            <div className="page-submenu d-flex justify-content-between align-content-center">
              <button
                type="button"
                className="tab-arrow left"
                onClick={scrollToLeft}
              >
                <div
                  style={{ cursor: 'pointer' }}
                  className={`fa fa-caret-left ${
                    +formData.scroll === 0 ? 'd-none' : ''
                  }`}
                />
              </button>
              <ul
                className="tab-list tab-scroll no-border scroll"
                ref={scrollref}
              >
                {Acl(permissions, ['E2E RPT TREASURY']) === true &&
                  Acl(permissions, ['E2E RPT ASSESSOR']) === false && (
                    <>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 1 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(1)}
                        >
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 2 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(2)}
                        >
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 3 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(3)}
                        >
                          Land Appraisal
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 4 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(4)}
                        >
                          Property Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 5 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(5)}
                        >
                          Superseded Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 6 ? 'active ' : ''
                          }`}
                          onClick={handleActivePage(6)}
                        >
                          Transactions
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 7 ? 'active ' : ''
                          }`}
                          onClick={handleActivePage(7)}
                        >
                          History
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 8 ? 'active ' : ''
                          }`}
                          onClick={handleActivePage(8)}
                        >
                          Payment History
                        </button>
                      </li>
                    </>
                  )}
                {Acl(permissions, ['E2E RPT TREASURY']) &&
                  Acl(permissions, ['E2E RPT ASSESSOR']) && (
                    <>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 1 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(1)}
                        >
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 2 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(2)}
                        >
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 3 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(3)}
                        >
                          Land Appraisal
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 4 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(4)}
                        >
                          Property Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 5 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(5)}
                        >
                          Superseded Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 6 ? 'active ' : ''
                          }`}
                          onClick={handleActivePage(6)}
                        >
                          Transactions
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 7 ? 'active ' : ''
                          }`}
                          onClick={handleActivePage(7)}
                        >
                          History
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 8 ? 'active ' : ''
                          }`}
                          onClick={handleActivePage(8)}
                        >
                          Payment History
                        </button>
                      </li>
                    </>
                  )}
                {Acl(permissions, ['E2E RPT TREASURY']) === false &&
                  Acl(permissions, ['E2E RPT ASSESSOR']) === true && (
                    <>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 1 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(1)}
                        >
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 2 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(2)}
                        >
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 3 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(3)}
                        >
                          Land Appraisal
                        </button>
                      </li>
                      <li className="tab-item">
                        <button
                          type="button"
                          className={`btn-blank py-2 px-3 ${
                            activeTab === 4 ? 'active' : ''
                          }`}
                          onClick={handleActivePage(4)}
                        >
                          Property Assessment
                        </button>
                      </li>
                    </>
                  )}
              </ul>
              <button
                type="button"
                className="tab-arrow right"
                onClick={scrollToRight}
              >
                <div
                  style={{ cursor: 'pointer' }}
                  className={`fa fa-caret-right ${
                    +formData.totalwidth === +formData.rightdistance
                      ? 'd-none'
                      : ''
                  }`}
                />
              </button>
            </div>
            <div className="tabs-details">
              {activeTab === 1 && <PropertyLocation data={applicationInfo} />}
              {activeTab === 2 && <Information data={applicationInfo} />}
              {activeTab === 3 && (
                <LandAppraisalContainer
                  applicationInfo={applicationInfo}
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
              {activeTab === 4 && (
                <LandPropertyAssessment
                  applicationId={applicationInfo.id}
                  applicationStatus={_.get(
                    applicationInfo,
                    'attributes.status'
                  )}
                />
              )}
              {activeTab === 5 && (
                <LandSupersededAssessment
                  applicationId={applicationId}
                  applicationType={_.get(
                    applicationInfo,
                    'included.transactionCode.attributes.code'
                  )}
                  applicationStatus={_.get(
                    applicationInfo,
                    'attributes.status'
                  )}
                />
              )}
              {activeTab === 6 && (
                <LandTransactionsContainer
                  data={applicationInfo}
                  applicationId={applicationInfo.id}
                  handleViewSOA={handleViewSOA}
                />
              )}
              {activeTab === 7 && (
                <LandHistoryContainer applicationId={applicationInfo.id} />
              )}
              {activeTab === 8 && (
                <PaymentHistory
                  applicationId={applicationInfo.id}
                  applicationInfo={applicationInfo}
                />
              )}
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

LandApplicationContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleCancel: PropTypes.instanceOf(Function).isRequired,
  handlePost: PropTypes.instanceOf(Function).isRequired,
  handleRevert: PropTypes.instanceOf(Function).isRequired,
  getSingleLandApplication: PropTypes.instanceOf(Function).isRequired,
  applicationInfo: PropTypes.instanceOf(Object).isRequired,
  applicationId: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  handleLogsModal: PropTypes.instanceOf(Function).isRequired,
  handleViewSOA: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  applicationInfo: _.get(api, `${c.GET_SINGLE_LAND_APPLICATION}.item`) || {},
  applicationId: _.get(match, 'params.applicationId') || '',
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandApplicationContent);
